export const CREATE_REQUEST_EXAM_REQUEST = "CREATE_REQUEST_EXAM_REQUEST"
export const CREATE_REQUEST_EXAM_SUCCESS = "CREATE_REQUEST_EXAM_SUCCESS"
export const CREATE_REQUEST_EXAM_FAILURE = "CREATE_REQUEST_EXAM_FAILURE"

export const GET_REQUEST_EXAMS_REQUEST = "GET_REQUEST_EXAMS_REQUEST"
export const GET_REQUEST_EXAMS_SUCCESS = "GET_REQUEST_EXAMS_SUCCESS"
export const GET_REQUEST_EXAMS_FAILURE = "GET_REQUEST_EXAMS_FAILURE"